export default "__VITE_ASSET__CN7j$aZb__"